import { FormElementV2ResponseDto } from "src/backend"

export const isFormElementATrust = (formElement: Pick<FormElementV2ResponseDto, 'sherpaEntityType'>): boolean => {
    return formElement.sherpaEntityType === 'TRUST'
}